var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgSortAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.93,
    height: 14.137,
    viewBox: "0 0 17.93 14.137"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-sort-ascending_svg__cls-1{fill:none;stroke:#7eaddb;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-sort-ascending_svg__ICN_Sort_Ascending_Enabled",
    "data-name": "ICN_Sort Ascending_Enabled",
    transform: "translate(-405.7 -253.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-sort-ascending_svg__Group_695",
    "data-name": "Group 695",
    transform: "rotate(180 211.25 133.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_54",
    "data-name": "Line 54",
    className: "kpmg-sort-ascending_svg__cls-1",
    transform: "translate(2.667 1.221)",
    d: "M0 0v10.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_55",
    "data-name": "Line 55",
    className: "kpmg-sort-ascending_svg__cls-1",
    d: "M0 2.441L2.667 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_56",
    "data-name": "Line 56",
    className: "kpmg-sort-ascending_svg__cls-1",
    transform: "translate(2.667)",
    d: "M0 0l2.667 2.441"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-sort-ascending_svg__Group_1430",
    "data-name": "Group 1430",
    transform: "translate(406.5 254.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_57",
    "data-name": "Line 57",
    className: "kpmg-sort-ascending_svg__cls-1",
    transform: "translate(0 11.998)",
    d: "M0 0h6.667"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_58",
    "data-name": "Line 58",
    className: "kpmg-sort-ascending_svg__cls-1",
    transform: "translate(1.333 7.999)",
    d: "M0 0h5.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_59",
    "data-name": "Line 59",
    className: "kpmg-sort-ascending_svg__cls-1",
    transform: "translate(2.667 3.999)",
    d: "M0 0h4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-sort-ascending_svg__Line_60",
    "data-name": "Line 60",
    className: "kpmg-sort-ascending_svg__cls-1",
    transform: "translate(4)",
    d: "M0 0h2.667"
  })))));
}

export default SvgKpmgSortAscending;